import React, { Component } from 'react';
import './Voting.scss';

import Checkbox from '../../UI/Checkbox/Checkbox';
import Button from '../../UI/Button/Button';
import apiFetch from '../../../utils/fetch';
import VotingResult from './VotingResult/VotingResult';
import Toast from '../../../components/modal/toast';

import uuidv4 from 'uuid';

const urls = window.votings.actions;
const placeholders = window.votings.placeholders;

class Voting extends Component {
    constructor(props) {
        super(props);

        const voting = props.voting;
        this.options = voting.options.map(option => ({
            id: option.id,
            text: option.text
        }));

        const result = this.formatResult(voting.options);

        this.state = {
            submitting: false,
            loading: false,
            voted: voting.voted,
            checked: voting.checked,
            result: result,
            showResult: voting.voted
        };
    }

    formatResult(options) {
        const result = {};
        options.forEach(option => {
            let users = [];
            if (option.users) {
                users = option.users.split(',');
            }
            result[option.id] = {
                users
            };
        });
        return result;
    }

    getAction(actionName, optionId) {
        let url = urls[actionName];
        if (!url) return false;
        url = url.replace(placeholders.voting, this.props.voting.id);

        if (optionId) {
            url = url.replace(placeholders.option, optionId);
        }

        return url;
    }

    checkOptionHandler = e => {
        if (this.state.checked) return;

        const id = e.target.dataset.id;

        this.setState({
            checked: id,
            submitting: true
        });

        let url = this.getAction('vote', id);

        apiFetch({
            url
        })
            .then(res => {
                console.log('result', res);

                if (res.success) {
                    const options = res.options.map(option => ({
                        id: option.optionId,
                        users: option.users
                    }));
                    let updatedResult = this.formatResult(options);

                    this.setState({
                        result: updatedResult,
                        checked: null,
                        voted: true,
                        showResult: true
                    });
                } else {
                    console.log('error', 1);
                    Toast.open(res.error || 'Что-то пошло не так', {
                        state: 'error'
                    });
                }
            })
            .catch(err => {
                console.log('error', 2, err);
                Toast.open('Что-то пошло не так', { state: 'error' });
            })
            .finally(() => {
                this.setState({
                    submitting: false
                });
            });
    };

    showResult = () => {
        this.setState({
            showResult: true,
            loading: true
        });

        const url = this.getAction('getResult');

        apiFetch({ url })
            .then(res => {
                console.log(res);
                if (res.success) {
                    const options = res.options.map(option => ({
                        id: option.optionId,
                        users: option.users
                    }));
                    let updatedResult = this.formatResult(options);
                    this.setState({
                        result: updatedResult
                    });
                }
            })
            .catch(err => {
                console.error(err);
            })
            .finally(() => {
                this.setState({
                    loading: false
                });
            });
    };

    showVoting = () => {
        this.setState({
            showResult: false,
            voted: false
        });
    };

    render() {
        const { checked, submitting, voted, result, showResult } = this.state;
        const { id, question } = this.props.voting;

        let html;
        if (!showResult) {
            html = (
                <>
                    <div className='voting__options'>
                        {this.options.map(option => {
                            return (
                                <div className='voting__option' key={option.id}>
                                    <Checkbox
                                        name={`voting-${id}`}
                                        type='radio'
                                        label={option.text}
                                        data-id={option.id}
                                        checked={checked === option.id}
                                        onChange={this.checkOptionHandler}
                                    />
                                </div>
                            );
                        })}

                        {submitting ? (
                            <div className='voting__loader'>
                                <svg width='40' height='40'>
                                    <use
                                        xlinkHref='#loader-icon'
                                        href='#loader-icon'
                                    />
                                </svg>
                            </div>
                        ) : null}
                    </div>

                    <footer className='voting__footer'>
                        <Button
                            modes={['link', 'large']}
                            onClick={this.showResult}
                        >
                            Посмотреть результаты
                        </Button>
                    </footer>
                </>
            );
        } else {
            const total = Object.keys(result).reduce((acc, key) => {
                return acc + result[key].users.length;
            }, 0);

            html = (
                <>
                    <div className='voting__result'>
                        {this.options.map(option => {
                            const { users } = result[option.id];
                            return (
                                <VotingResult
                                    key={option.id}
                                    text={option.text}
                                    users={users}
                                    total={total}
                                />
                            );
                        })}
                    </div>
                    {total > 0 ? (
                        ''
                    ) : (
                        <div className='color_d-secondary'>
                            Еще никто не проголосовал
                        </div>
                    )}
                    <footer className='voting__footer'>
                        <Button
                            modes={['link', 'large']}
                            onClick={this.showVoting}
                        >
                            {voted ? 'Переголосовать' : 'Проголосовать'}
                        </Button>
                    </footer>
                </>
            );
        }

        return (
            <section className='voting'>
                {question ? (
                    <h3 className='voting__title'>{question}</h3>
                ) : null}
                {html}
            </section>
        );
    }
}

export default Voting;
